import React from "react";
import FormInput from "../components/FormInput";
import FormSelect from "../components/FormSelect";
import FormTextarea from "../components/FormTextarea";
import FormMultiSelect from "../components/FormMultiSelect";
import {
  PersonIcon,
  BuildingIcon,
  CallIcon,
  CalendarIcon,
  LocationIcon,
} from "../../../../images/icons/icons";

const BasicInformationSection = ({
  formValues,
  setFormValues,
  formErrors,
  onChangeInput,
  assignRef,
  isReOnboard,
  isApproval,
  isAdmin,
  rowData,
  onboarding_staff_types,
  gymData,
  trainerExperties,
}) => {
  // Single gym dropdown — for everyone EXCEPT cluster_manager (which needs multi-gym)
  const isGymShow =
    formValues.selectedStaffType?.value !== "cluster_manager";

  // Multi-gym dropdown — only for cluster_manager
  const isMultiGymShow =
    formValues.selectedStaffType?.value === "cluster_manager";

  return (
    <div className="staff-onboarding-form-section">
      <div className="staff-onboarding-section-header">
        <h3 className="staff-onboarding-section-title">Basic Information</h3>
        <p className="staff-onboarding-section-subtitle">
          Staff personal and role details
        </p>
      </div>

      <div className="staff-onboarding-section-content">
        <div className="staff-onboarding-form-grid">
          <FormSelect
            icon={PersonIcon}
            label="Staff Type"
            name="selectedStaffType"
            options={onboarding_staff_types}
            selectedOption={formValues.selectedStaffType}
            setSelectedOption={(selectedValue) =>
              setFormValues((prevs) => ({
                ...prevs,
                selectedStaffType: selectedValue,
                selectedExperties: [],
              }))
            }
            error={formErrors?.selectedStaffType}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("selectedStaffType")}
          />

          {isGymShow && (
            <FormSelect
              icon={BuildingIcon}
              label="Gym Name"
              name="selectedGym"
              options={gymData}
              selectedOption={formValues.selectedGym}
              setSelectedOption={(selectedValue) =>
                setFormValues((prevs) => ({
                  ...prevs,
                  selectedGym: selectedValue,
                }))
              }
              error={formErrors?.selectedGym}
              required={true}
              onRef={assignRef("selectedGym")}
            />
          )}

          {isMultiGymShow && (
            <FormMultiSelect
              icon={BuildingIcon}
              label="Select Gyms"
              name="selectedGyms"
              options={gymData || []}
              state={formValues.selectedGyms || []}
              setState={(selectedValue) =>
                setFormValues((prevs) => ({
                  ...prevs,
                  selectedGyms: selectedValue,
                }))
              }
              error={formErrors?.selectedGyms}
              required={true}
              onRef={assignRef("selectedGyms")}
              placeholder="Select one or more gyms"
            />
          )}

          <FormInput
            icon={PersonIcon}
            label="Full Name"
            name="staffName"
            placeholder="Enter full name"
            value={formValues.staffName}
            onChange={onChangeInput}
            error={formErrors?.staffName}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("staffName")}
          />

          <FormInput
            icon={CallIcon}
            label="Emergency Contact"
            name="staffEmergencyContactNumber"
            type="tel"
            placeholder="Enter contact number"
            value={formValues.staffEmergencyContactNumber}
            onChange={onChangeInput}
            error={formErrors?.staffEmergencyContactNumber}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("staffEmergencyContactNumber")}
          />

          <FormInput
            icon={CalendarIcon}
            label="Joining Date"
            name="joiningDate"
            type="date"
            value={formValues.joiningDate}
            onChange={onChangeInput}
            error={formErrors?.joiningDate}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("joiningDate")}
          />

          <FormInput
            icon={CalendarIcon}
            label="Date of Birth"
            name="staffDob"
            type="date"
            value={formValues.staffDob}
            onChange={onChangeInput}
            error={formErrors?.staffDob}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("staffDob")}
          />

          {isAdmin && (
            <FormInput
              label="Staff Salary"
              name="staffSalary"
              type="number"
              placeholder="Enter salary amount"
              value={formValues.staffSalary}
              onChange={onChangeInput}
              error={formErrors?.staffSalary}
              // disabled={!isReOnboard && rowData?.approval_status}
              disabled={!isReOnboard && rowData?.is_exists}
              required={isApproval || isReOnboard}
              onRef={assignRef("staffSalary")}
            />
          )}

          {formValues.selectedStaffType?.value === "trainer" && (
            <FormMultiSelect
              icon={PersonIcon}
              label="Select Expertise"
              name="selectedExperties"
              options={trainerExperties}
              state={formValues.selectedExperties}
              setState={(selectedValue) =>
                setFormValues((prevs) => ({
                  ...prevs,
                  selectedExperties: selectedValue,
                }))
              }
              error={formErrors.selectedExperties}
              disabled={isReOnboard}
              required={true}
              onRef={assignRef("selectedExperties")}
            />
          )}

          <FormInput
            icon={LocationIcon}
            label="Postal Code"
            name="pinCode"
            type="number"
            placeholder="Enter 6-digit PIN code"
            value={formValues.pinCode}
            onChange={onChangeInput}
            error={formErrors?.pinCode}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("pinCode")}
          />
        </div>

        <FormTextarea
          icon={LocationIcon}
          label="Full Address"
          name="fullAddress"
          placeholder="Enter complete address"
          value={formValues.fullAddress}
          onChange={onChangeInput}
          error={formErrors?.fullAddress}
          disabled={isReOnboard}
          required={true}
          onRef={assignRef("fullAddress")}
        />

        {/* <div className="staff-onboarding-form-grid staff-onboarding-limited-width">
          <FormInput
            icon={LocationIcon}
            label="Postal Code"
            name="pinCode"
            type="number"
            placeholder="Enter 6-digit PIN code"
            value={formValues.pinCode}
            onChange={onChangeInput}
            error={formErrors?.pinCode}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("pinCode")}
          />
        </div> */}
      </div>
    </div>
  );
};

export default BasicInformationSection;
